import React from "react";
import MainLink from "./MainLink";
import Sidebar from "../Sidebar";
import {useAuth} from "@/context/user";
export type NavLinks = {
  slug: string;
  label: string;
  path: string;
  rolesAllowed: string[];
};

export default function SidebarLinks({
  title,
  navLinks,
  innerLinks,
  innerLinksTitle,
}: {
  title: string;
  navLinks: NavLinks[] | undefined;
  innerLinks?: NavLinks[];
  innerLinksTitle?: string;
}) {

  const {developerAccess} = useAuth()

  return (
    <Sidebar title={title} fitContent={false}>
      <nav className="flex flex-col gap-2.5 px-0.5 sm:px-1.5">
        {navLinks?.map((navLink) => {
          return (
            <MainLink
              key={navLink.slug}
              path={navLink.path}
              title={navLink.label}
              slug={navLink.slug}
              innerLinks={navLink.label === innerLinksTitle ? innerLinks : []}
            />
          );
        })}
        {developerAccess && <MainLink
          key="api-keys"
          path="/settings/api-keys"
          title={"API Keys"}
          slug={"api-keys"}
          innerLinks={"API Keys" === innerLinksTitle ? innerLinks : []}

        />}
      </nav>
    </Sidebar>
  );
}
